import actionTypes from 'redux/actions/actionTypes'
import tooltipTypes from 'helpers/enums/tooltipTypes'
import topInformationTypes from 'helpers/enums/topInformationTypes'

const defaultState = {
	logged: null,
	extra: null,
	permissions: {
		hasAccessToVideoLessonsFromStore: false,
		_isLoaded: false,
	},
	complementaryData: null,
	data: {},
	fullDataLoaded: false,
	new_user: false,
	shownModals: {
		lms: false,
		sso: false,
	},
	featureFlagsHash: 0,
	credentials: {
		interactiveVideo: '',
		default: '',
	},
}

function setExtraData(state, action) {
	const newState = {...state}
	newState.extra = {
		...action.payload,
		_isLoaded: true,
	}
	if (state.extra && state.extra.tooltips['tooltipOBLiveSession'] === 1) {
		newState.extra.tooltips['tooltipOBLiveSession'] = 1
	}
	if (state.extra && state.extra.tooltips[tooltipTypes.NICKEL_TOUR] === 1) {
		newState.extra.tooltips[tooltipTypes.NICKEL_TOUR] = 1
	}
	return newState
}

function setPermissions(state, action) {
	const newState = {...state}
	newState.permissions = {
		...action.payload.permissions,
		_isLoaded: true,
	}
	return newState
}

function removeOverlay(state) {
	const newState = {
		...state,
		extra: {
			...state.extra,
			notificationMessage: null,
		},
	}
	return newState
}

function removeConfirm(state) {
	const newState = {
		...state,
		data: {
			...state.data,
			notificationMessage: null,
		},
	}
	return newState
}

function updateTooltip(state, action) {
	return updateTooltipStatus(state, action.tooltipName)
}

function updateTooltips(state, action) {
	let newState = {...state}
	action.tooltipNames.forEach(tooltip => {
		newState = updateTooltipStatus(newState, tooltip)
	})
	return newState
}

function setUserData(state, action) {
	const newState = {...state}
	newState.data = action.payload
	newState.fullDataLoaded = action.fullData ? true : false
	return newState
}

function dismissRedirection(state) {
	const newState = {...state}
	const data = {...state.data}
	data.redirectUrl = ''
	newState.data = data
	return newState
}

function updateAcceptedTerms(state) {
	if (state.extra && state.extra.hasAcceptedSubsTerms === '0') {
		const newState = {...state}
		newState.extra = {...state.extra, ...{hasAcceptedSubsTerms: '1'}}
		return newState
	}
	return state
}

function updateLibrariesData(state, action) {
	let changed = false, newLibraries
	if (state.extra && state.extra.libraries) {
		newLibraries = state.extra.libraries.map(function(item) {
			if (item.id === action.libraryUID && item.new_lessons !== '0') {
				changed = true
				return {...item, ...{new_lessons: '0'}}
			}
			return item
		})
	}
	if (changed) {
		const newState = {...state}
		newState.extra = {...state.extra}
		newState.extra.libraries = newLibraries
		return newState
	}
	return state
}

function savePersonalInfo(state, action) {
	const newState = {...state}
	const newData = {...state.data}
	newData.firstName = action.firstName
	newData.lastName = action.lastName
	newData.email = action.email
	newState.data = newData
	return newState
}

function setProfileImage(state, action) {
	const newState = {...state}
	const newData = {...state.data}
	newData.image = action.icon.versions.default
	newState.data = newData
	return newState
}

function updateTooltipStatus(state, tooltipName) {
	const newState = {...state}
	newState.extra = {...state.extra}
	newState.extra.tooltips = {...state.extra.tooltips}
	newState.extra.tooltips[tooltipName] = 0
	return newState
}

function setProfilePreviewImage(state, action) {
	const newState = {...state}
	const newData = {...state.data}
	newData.image = action.image
	newState.data = newData
	return newState
}

function updateComplementaryData(state, action) {
	return {
		...state,
		complementaryData: action.data,
	}
}

function setLmsModalStatus(state) {
	const newState = {...state}
	newState.shownModals={...state.shownModals}
	newState.shownModals.lms = true
	return newState
}

function setLoginSSOErrorConfirmStatus(state) {
	return {
		...state,
		shownModals: {
			...state.shownModals,
			sso: true,
		},
	}
}

function setFeatureFlags(state) {
	return {
		...state,
		featureFlagsHash: Date.now(),
	}
}

function setOfferTitle(state, action) {
	const newState = {...state}
	if (newState.extra) {
		newState.extra = {...state.extra}
		newState.extra.notificationMessage = newState.extra.notificationMessage ? {...state.extra.notificationMessage} : {}
	} else {
		newState.extra = {
			notificationMessage: {},
		}
	}
	newState.extra.notificationMessage.offerTitle = action.offerTitle
	return newState
}

function updateNewUserState(state, action) {
	const newState = {...state}
	if (!action.data.verifyCorporateAccount) {
		newState.logged = true
		newState.new_user = true
		newState.data = action.data
	}
	return newState
}

// This function is not in use now, but we decided to leave it for future use as part of the banner architecture, the linter rule was added to avoid error.
// eslint-disable-next-line no-unused-vars
function setNotificationBannerType(state, action) {
	const newState = {...state}
	newState.extra = {...state.extra}
	newState.extra.notificationBanner = state.extra ? {...state.extra.notificationBanner} : {}
	newState.extra.notificationBanner.type = action.bannerType
	return newState
}

function handleTopInformationClose(state, action) {
	switch (action.uid) {
		case topInformationTypes.GOOGLE_SLIDES_CANNOT_COPY_PASTE_SLIDES:
			return updateTooltipStatus(
				state,
				tooltipTypes.GOOGLE_SLIDES_CANNOT_COPY_PASTE_SLIDES
			)
		default:
			return state
	}
}

function handleUserTooltipFirstLiveSession(state) {
	return updateTooltipStatus(state, 'tooltipOBLiveSession')
}

function handleCollaborateCardTooltipConfirmed(state) {
	return updateTooltipStatus(state, tooltipTypes.NICKEL_TOUR)
}

function setInteractiveVideoJwt(state, action) {
	return {
		...state,
		credentials: {
			...state.credentials,
			interactiveVideo: action.jwt,
		},
	}
}

function setDefaultJwt(state, action) {
	return {
		...state,
		credentials: {
			...state.credentials,
			default: action.data.jwt,
		},
		logged: true,
	}
}

const userReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.USER_IS_LOGGED:
		case actionTypes.USER_IS_AUTOLOGGED:
		{
			const newState = {...state}
			newState.logged = true
			return newState
		}
		case actionTypes.SIGNUP_SEND_EMAIL_FORM_SUCCESS:
		case actionTypes.SIGNUP_SEND_SSO_FORM_SUCCESS: {
			return updateNewUserState(state, action)
		}
		case actionTypes.USER_IS_NOT_LOGGED: {
			const newState = {...state}
			newState.logged = false
			return newState
		}
		case actionTypes.USER_EXTRA_DATA: {
			return setExtraData(state, action)
		}
		case actionTypes.USER_PERMISSIONS_FETCH_SUCCESS: {
			return setPermissions(state, action)
		}
		case actionTypes.BINDERS_BINDER_CREATE_NEW: {
			return updateAcceptedTerms(state, action)
		}
		case actionTypes.USER_UPDATE_TOOLTIP:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_LETS_DO_IT:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_WELCOME_MODAL_LETS_DO_IT:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_1_GOT_IT:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_2_GOT_IT:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_3_GOT_IT:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_TRIM_TOOLTIP_GOT_IT:
		case actionTypes.INTERACTIVE_VIDEO_TOOLTIP_CHECK_PROGRESS_DISMISSED:
		{
			return updateTooltip(state, action)
		}
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_SKIP_TOUR:
		{
			return updateTooltips(state, action)
		}
		case actionTypes.DISMISS_REDIRECTION: {
			return dismissRedirection(state, action)
		}
		case actionTypes.USER_DATA_FETCHED: {
			return setUserData(state, action)
		}
		case actionTypes.PRIVATE_LIBRARY_LESSONS_FETCHED: {
			return updateLibrariesData(state, action)
		}
		case actionTypes.MY_ACCOUNT_SAVE_PERSONAL_INFO_SUCCESS: {
			return savePersonalInfo(state, action)
		}
		case actionTypes.MY_ACCOUNT_SAVE_ICON_SUCCESS: {
			return setProfileImage(state, action)
		}
		case actionTypes.MY_ACCOUNT_NEARPOD_PICKER_FILE_PREVIEW: {
			return setProfilePreviewImage(state, action)
		}
		case actionTypes.USER_COMPLEMENTARY_DATA_FETCHED: {
			return updateComplementaryData(state, action)
		}
		case actionTypes.LMS_MODAL_CONFIRMED: {
			return setLmsModalStatus(state)
		}
		case actionTypes.LOGIN_SSO_ERROR_CONFIRM_CONFIRMED: {
			return setLoginSSOErrorConfirmStatus(state)
		}
		case actionTypes.FEATURE_FLAGS_GET_SUCCESS:
		case actionTypes.STUDENT_INITIALIZE_POLL:
		case actionTypes.STUDENT_INITIALIZE_QUIZ:
		case actionTypes.STUDENT_INITIALIZE_OEQ:
		case actionTypes.STUDENT_INITIALIZE_DRAW_IT:
		case actionTypes.MATCHING_PAIRS_STUDENT_INITIALIZE:
		case actionTypes.STUDENT_INITIALIZE_LEAD:
		case actionTypes.STUDENT_INITIALIZE_READ_ONLY:
		case actionTypes.INTERACTIVE_VIDEO_STANDALONE_INITIALIZE:
		{
			return setFeatureFlags(state)
		}
		case actionTypes.BINDERS_ONBOARDING_ANIMATION_COMPLETED:
		case actionTypes.BINDERS_ONBOARDING_FAILED:
		case actionTypes.MY_LIBRARY_SCHOOL_FREE_TRIAL_ONBOARDING_OVERLAY_FAILED:
		case actionTypes.MY_LIBRARY_TIME_TO_CLIMB_CANCELLED:
		case actionTypes.MY_LIBRARY_FIRST_LESSON_COMPLETED:
		case actionTypes.MY_LIBRARY_FIRST_LESSON_FILE_UPLOADED_ERROR:
		case actionTypes.MY_LIBRARY_FIRST_LESSON_CLOSED:
		case actionTypes.MY_LIBRARY_GRADES_SUBJECTS_SUBMIT:
		case actionTypes.MY_LIBRARY_GRADES_SUBJECTS_DISMISS:
		case actionTypes.MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_DISMISS:
		case actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_GO_TO_MY_LIBRARY:
		case actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_SHOW_MY_LIBRARY:
		case actionTypes.MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_CONFIRM:
		case actionTypes.MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_DISMISS:
		case actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_SEND:
		case actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_CLOSE:
		case actionTypes.DM_STORAGE_EXPERIMENT_GO_TO_MY_LIBRARY:
		case actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_EXPLORE_LESSONS:
		case actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_GO_TO_MY_LIBRARY:
		case actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_COLLEAGUES_SUCCESS:
		case actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_GO_TO_MY_LIBRARY:
		case actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_CLOSE:
		case actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_SEND:
		case actionTypes.OVERLAY_DISTRICT_LIBRARY_ONBOARDING_CONFIRM:
		case actionTypes.OVERLAY_SCHOOL_LIBRARY_ONBOARDING_CONFIRM:
		case actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_DISMISS:
		case actionTypes.MY_LIBRARY_SUBS_OVERLAY_LEARN_MORE:
		case actionTypes.MY_LIBRARY_SUBS_OVERLAY_DISMISS:
		case actionTypes.MY_LIBRARY_FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED:
		case actionTypes.MY_LIBRARY_FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED_FAILED:
		case actionTypes.FLOCABULARY_WARNING_OVERLAY_FINISHED:
		case actionTypes.MY_LIBRARY_IMMERSIVE_READER_CANCELLED:
		case actionTypes.MY_LIBRARY_IMMERSIVE_READER_CONFIRMED:
		case actionTypes.NICKEL_TOUR_CLOSE:
		case actionTypes.NICKEL_TOUR_COMPLETED:
			return removeOverlay(state)
		case actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_INITIALIZE:
		case actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_INITIALIZE:
		case actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_INITIALIZE:
		case actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_INITIALIZE: {
			return setOfferTitle(state, action)
		}
		case actionTypes.MY_LIBRARY_SCHOOL_JOIN_CONFIRM_CLOSE:
		case actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_NOSLOTS_CLOSE:
		case actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_YES:
		case actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_NO:
		case actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_CLOSE:
		case actionTypes.MY_LIBRARY_CLOSE_PLATINUM_DOWNGRADE_ACCOUNT:
		case actionTypes.MY_LIBRARY_CLOSE_AYCE_DOWNGRADE_ACCOUNT:
		case actionTypes.MY_LIBRARY_CLOSE_FEATURE_DOWNGRADE_ACCOUNT:
		case actionTypes.MY_LIBRARY_FEATURE_REDEEM_FAIL_CONFIRM:
		case actionTypes.MY_LIBRARY_PAYWALL_REMINDER_UPGRADE:
		case actionTypes.MY_LIBRARY_PAYWALL_REMINDER_CLOSE:
		case actionTypes.MY_LIBRARY_PAYWALL_UPGRADE_NOW:
		case actionTypes.MY_LIBRARY_PAYWALL_DISMISS:
		case actionTypes.MY_LIBRARY_PAYWALL_EXPIRED_UPGRADE:
		case actionTypes.MY_LIBRARY_PAYWALL_EXPIRED_CLOSE: {
			return removeConfirm(state)
		}
		case actionTypes.CLOSE_TOP_INFORMATION:
			return handleTopInformationClose(state, action)
		case actionTypes.MY_LIBRARY_LAUNCH_LIVE_LESSON:
		case actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK:
			return handleUserTooltipFirstLiveSession(state)
		case actionTypes.GOALS_COLLABORATE_CARD_CREATE_LESSON_WITH_DEMO:
			return handleCollaborateCardTooltipConfirmed(state)
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_SELECT_ROUTE:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_SCREENSHOT_ROUTE:
		case actionTypes.VIDEO_INITIALIZE_PICKER_ROUTE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_PICKER_ROUTE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_EDIT_ROUTE:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_INITIALIZE:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_INITIALIZE:
		case actionTypes.INTERACTIVE_VIDEO_SESSION_INITIALIZE:
		case actionTypes.INTERACTIVE_VIDEO_PREVIEW_INITIALIZE:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_BASE:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_EDIT:
		case actionTypes.VIDEO_INITIALIZE_CREATION_TOOL_BASE:
		case actionTypes.VIDEO_INITIALIZE_EDIT_ROUTE:
		case actionTypes.VIDEO_CREATION_MCQ_INITIALIZE:
		case actionTypes.VIDEO_CREATION_OEQ_INITIALIZE:
		case actionTypes.VIDEO_STANDALONE_MCQ_INITIALIZE:
		case actionTypes.VIDEO_STANDALONE_OEQ_INITIALIZE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_BASE:
			return setInteractiveVideoJwt(state, action)
		case actionTypes.LOGIN_STUDENT_SUBMIT_LOGIN_GOOGLE_TOKEN_SUCCESS:
		case actionTypes.LOGIN_STUDENT_SUBMIT_LOGIN_OFFICE_365_TOKEN_SUCCESS:
		case actionTypes.STUDENT_SUBMIT_LEAD_GOOGLE_TOKEN_SUCCESS:
		case actionTypes.STUDENT_SUBMIT_LEAD_OFFICE_365_TOKEN_SUCCESS:
			return setDefaultJwt(state, action)
		default:
			return state
	}
}

export default userReducer

export {
	defaultState,
}
